"use client";
import { Title as StyledTitle } from "./Title.styles";
import PropTypes from "prop-types";

const Title = ({ children, sx, style }) => (
  <StyledTitle variant={"h2"} component={"div"} {...sx} {...style}>
    {children}
  </StyledTitle>
);

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  sx: PropTypes.instanceOf(Object),
  style: PropTypes.instanceOf(Object),
};

export default Title;
